{% block sw_category_upselling %}
    <div class="sw-category-upselling">
        {% block sw_category_upselling_items %}
            <ul v-if="upsellings && upsellings.length > 0" class="sw-category-upselling__upselling-list">
                <sw-category-upselling-form
                    v-for="item in upsellings"
                    :key="item.id"
                    :upselling="item">
                </sw-category-upselling-form>
            </ul>
        {% endblock %}

        {% block sw_category_upselling_empty_state_card %}
            <mt-card
                    v-else
                    position-identifier="sw-category-upselling-empty-state"
            >
                {% block sw_category_upselling_empty_state %}
                    <sw-empty-state
                            :absolute="false"
                            empty-module
                    >
                        {% block sw_category_upselling_empty_state_icon %}
                            <template #icon>
                                <img
                                        :src="assetFilter('/administration/administration/static/img/empty-states/products-empty-state.svg')"
                                        alt=""
                                >
                            </template>
                        {% endblock %}

                        {% block sw_category_upselling_empty_state_content_empty %}
                            <p>{{ $tc('sw-category.upselling.emptyStateDescription') }}</p>
                        {% endblock %}

                        {% block sw_category_upselling_empty_state_actions %}
                            <template #actions>
                                <mt-button
                                        ghost
                                        :disabled="false"
                                        variant="secondary"
                                        @click="onAddUpselling"
                                >
                                    {{ $tc('sw-category.upselling.buttonAddUpselling') }}
                                </mt-button>
                            </template>
                        {% endblock %}
                    </sw-empty-state>
                {% endblock %}
            </mt-card>
            {% block sw_category_upselling_add %}
                <mt-button
                        v-if="upsellings && upsellings.length > 0"
                        class="sw-category-upselling__add-btn"
                        ghost
                        variant="secondary"
                        @click="onAddUpselling"
                        :disabled="false"
                >
                    {{ $tc('sw-category.upselling.buttonAddUpselling') }}
                </mt-button>
            {% endblock %}
        {% endblock %}
    </div>
{% endblock %}
